import { render, staticRenderFns } from "./systemmanagement.vue?vue&type=template&id=8caa60fc&scoped=true&"
import script from "./systemmanagement.vue?vue&type=script&lang=js&"
export * from "./systemmanagement.vue?vue&type=script&lang=js&"
import style0 from "./systemmanagement.vue?vue&type=style&index=0&id=8caa60fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caa60fc",
  null
  
)

export default component.exports